/* eslint-disable no-param-reassign */
import Vue, { DirectiveOptions } from 'vue';

const toggleControls = (el: HTMLElement, value: boolean) => {
  const inputs = Array.from(el.getElementsByTagName('input'));
  const btns = Array.from(el.getElementsByTagName('button'));
  const selects = Array.from(el.getElementsByTagName('select'));
  const controls = [...inputs, ...btns, ...selects];

  controls.forEach((control) => {
    control.disabled = value;
  });

  el.style.opacity = value ? '.5' : '1';
  el.style.pointerEvents = value ? 'none' : '';
};

const options: DirectiveOptions = {
  inserted(el: HTMLElement, { value }) {
    el.style.transition = 'opacity .2s';

    if (value || value === undefined) {
      toggleControls(el, true);
    }
  },
  update(el: HTMLElement, { value, oldValue }) {
    if (oldValue !== value) {
      const disable = value || value === undefined;
      toggleControls(el, disable);
    }
  },
};

Vue.directive('disable-all', options);
